import styled, { css } from 'styled-components';
import { em, rem } from 'styles';

export const Select = styled.select`
  ${({ theme }) => css`
    width: 100%;
    padding: ${em(5)} ${em(10)};
    font-size: ${rem(15)};
    color: ${theme.colors.nature.n5};
    background: ${theme.colors.nature.n0};
    border: ${em(1)} solid ${theme.colors.nature.n2};
    border-radius: ${em(theme.radius[0])};
    cursor: pointer;
  `}
`;
